import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { userFinishedOrientationThunk } from "../../store/thunks";
import { useDispatch, useSelector } from "react-redux";
import { useClearCurrentTopic } from "../../hooks/useClearCurrentTopic";
import { useTranslation } from "react-i18next";
import { trackAdobeAppClick, trackAdobeClick } from "../../utils/adobeLogging";

const Orientation = () => {
  useClearCurrentTopic();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const section = useSelector((state) => state.progress.section);
  const lang = useSelector((state) => state.ui.lang);
  
  const activity = useSelector((state) => {
    const approach = state.progress.section;
    if (approach === "PMAgile") {
      return state.activities["agile-orientation"];
    }
    if (approach === "PMWaterfall") {
      return state.activities["waterfall-orientation"];
    }
  });

  useEffect(() => {
    const skipHandler = (e) => {
      trackAdobeAppClick({ action: "skip-tutorial",language: lang });
      trackAdobeClick(
        null,
        {
          linkTitle: "skip tutorial",
          linkModule: `${section}-orientation`,
          targetURL: "/app",
        },
        false
      );

      history.push("/app");
    };
    const doneHandler = (e) => {
      dispatch(userFinishedOrientationThunk());
      trackAdobeClick(null, {
        linkTitle: t("continue"),
        linkModule: `${section}-orientation`,
        targetURL: "/app",
      });
      history.push("/app");
    };
    const continueHandler = (event) =>{
      trackAdobeClick(null, {
        linkTitle: `${t("continue")}:${event?.detail}`,
        linkModule: `${section}-orientation`,
        targetURL: null,
      });
    }

    window.addEventListener("done", doneHandler);
    window.addEventListener("skip", skipHandler);
    window.addEventListener("continue", continueHandler);

    return () => {
      window.removeEventListener("done", doneHandler);
      window.removeEventListener("skip", skipHandler);
      window.removeEventListener("continue", continueHandler);
    };
  }, []);

  return (
    <div id="orientation" adoberegion={`${section}-orientation`}>
      <div className="lg:px-0 px-3">
        <div className="bg-white shadow rounded">
          <div>
            <div dangerouslySetInnerHTML={{ __html: activity.fullContent }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Orientation;
